import axiosInstance from './AxiosInstance';

class ContestationPeriodsService {

    constructor() {
        this.endpoint = "/api/politicalparties"
    }

    async getContestationPeriods() {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/membership-periods?ActiveOnly=true`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return { success: false, message: 'fail to proccess request' }
        }
    }
    async createContestationPeriods(data) {
        try {
            const response = await axiosInstance.post(`${this.endpoint}/membership-periods`, data);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return { success: false, message: 'fail to proccess request' }
        }
    }

    async updatePoliticalPartycontestationYears(data) {
        var url = `${this.endpoint}/contestation-years`;
        return axiosInstance.post(url, data).then((response) => response.data);
    };


    async updateContestationPeriods(data) {
        try {
            const response = await axiosInstance.patch(`${this.endpoint}/membership-periods/${data.contestationPeriodID}`, data);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return { success: false, message: 'fail to proccess request' }
        }
    }

}

export var contestationPeriodsService = new ContestationPeriodsService()
